import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class SalesService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of sales possibilities.
     *
     * @datatask 1408
     * @datataskName sp_ws_p2_sales_possibility_list
     * @returns promise containing list of sales possibilities.
     */
    public getSalesPossibilities(): Promise<SalesPossibilityItem[]> {
        return this.datatask.Post(1408);
    }

    /**
     * Retrieses list of sales sizes.
     *
     * @datatask 1409
     * @datataskName sp_ws_p2_sales_size_list
     * @returns promise containig list of sales sizes.
     */
    public getSalesSizes(): Promise<SalesSizeItem[]> {
        return this.datatask.Post(1409);
    }
}

export interface SalesPossibilityItem {
    sales_possibility_no: string;
    sales_possibility_name: string;
    orderby: string;
}

export interface SalesSizeItem {
    sales_size_no: string;
    sales_size_name: string;
    orderby: string;
}
